import { DeleteOutlined } from "@ant-design/icons";
import { FormInstance } from "antd";
import CustomInput from "../../../commons/components/CustomInput/CustomInput";
import UploadFile from "../../../commons/components/UploadFile/UploadFile";
import { UpdateAccountInformationFormFields } from "../../../commons/constants/formField";
import { DocumentTextIcon } from "../../../commons/resources";
import { filterECharacterInputNumber, integerOnlyInput } from "../../../commons/utils/functions/integerOnly";
import removeExtraSpace from "../../../commons/utils/functions/removeExtraSpace";
import styles from "../../../components/AccountInformation/AccountInformation.module.scss";

interface MerchantInformationProps {
  form: FormInstance;
  data: any;
  setData: any;
  handleTrackFieldsTouched: (fieldName: string) => void;
}

const MerchantInformation: React.FC<MerchantInformationProps> = ({ form, data, setData, handleTrackFieldsTouched }) => {
  return (
    <>
      <h2 className={styles.infoTitle}>Merchant Information</h2>
      <div className={styles.detail} style={{ border: "none" }}>
        <div className={styles.column}>
          {UpdateAccountInformationFormFields.slice(4, 9).map((field, idx) => {
            if (field.type === "number") {
              return (
                <CustomInput
                  className={styles.input}
                  label={field.title}
                  key={idx}
                  type={field.type}
                  onKeyDown={event => {
                    integerOnlyInput(event);
                  }}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                    filterECharacterInputNumber(field.name, form, e);
                  }}
                  onMouseLeave={() => {}}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            } else {
              return (
                <CustomInput
                  key={idx}
                  className={styles.input}
                  label={field.title}
                  type={field.type}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                  onChange={() => {
                    handleTrackFieldsTouched(field.name);
                  }}
                />
              );
            }
          })}
        </div>
        <div className={[styles.column, styles.secondColumn].join(" ")}>
          {UpdateAccountInformationFormFields.slice(9, 12).map((field, idx) => {
            if (field.type === "number") {
              return (
                <CustomInput
                  className={styles.input}
                  key={idx}
                  label={field.title}
                  type={field.type}
                  onKeyDown={event => {
                    integerOnlyInput(event);
                  }}
                  onChange={e => {
                    handleTrackFieldsTouched(field.name);
                    filterECharacterInputNumber(field.name, form, e);
                  }}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            } else {
              return (
                <CustomInput
                  className={styles.input}
                  key={idx}
                  label={field.title}
                  type={field.type}
                  maxLength={100}
                  rules={field.rule}
                  placeholder={field.placeholder}
                  name={field.name}
                  onChange={() => {
                    handleTrackFieldsTouched(field.name);
                  }}
                  onBlur={removeExtraSpace(field.name, form)}
                  style={{ marginBottom: "0px" }}
                />
              );
            }
          })}
          <div className={styles.documents}>
            <div className={styles.label}>Documentation *</div>
            <div className={styles.documentBox}>
              {data?.information?.merchantApprovals?.documents?.length > 0 ? (
                <>
                  {data?.information?.merchantApprovals?.documents.map((document: string) => {
                    return (
                      <a key={document} href={document} target="_blank" rel="noreferrer">
                        <div className={styles.document} key={document}>
                          <DocumentTextIcon />
                          {document.split("/").at(-1)}
                          <DeleteOutlined
                            onClick={e => {
                              e.preventDefault();
                              setData((prev: any) => {
                                return {
                                  ...prev,
                                  information: {
                                    ...prev.information,
                                    merchantApprovals: {
                                      ...prev.information.merchantApprovals,
                                      documents: prev.information.merchantApprovals.documents.filter(
                                        (item: string) => item !== document
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                          />
                        </div>
                      </a>
                    );
                  })}
                </>
              ) : (
                <>
                  {" "}
                  {data?.information?.documents.map((document: string) => {
                    return (
                      <a key={document} href={document} target="_blank" rel="noreferrer">
                        <div className={styles.document} key={document}>
                          <DocumentTextIcon />
                          {document.split("/").at(-1)}
                          <DeleteOutlined
                            onClick={e => {
                              e.preventDefault();
                              setData((prev: any) => {
                                return {
                                  ...prev,
                                  information: {
                                    ...prev.information,
                                    merchantApprovals: {
                                      ...prev.information.merchantApprovals,
                                      documents: prev.information.merchantApprovals.documents.filter(
                                        (item: string) => item !== document
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                          />
                        </div>
                      </a>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.detail}>
        <div style={{ flex: 1 }}>
          <UploadFile
            rules={[]}
            description={
              <p>
                Upload business document(s),
                <br /> accepted formats: .pdf, .jpg, .png, .doc, .docx, .pdf
              </p>
            }
            label={undefined}
            name="new_documents"
            multiple={true}
            maxCount={3}
            className={styles.uploadFile}
          />
        </div>
      </div>
    </>
  );
};

export default MerchantInformation;
